import { StakeButton } from '@app/screens/nft-marketplace/StakeButton';
import { CartButton } from '@app/screens/nft-marketplace/CartButton';
import React, { FC } from 'react';
import { HStack } from '@chakra-ui/react';

type Props = {};

export const StakeCartButtonsContainer: FC<Props> = () => {
  return (
    <HStack gap={3} width={['100%', 'unset']}>
      <StakeButton />
      <CartButton />
    </HStack>
  );
};
